import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { map, take } from 'rxjs/operators';
import { DisconnectDialogBoxComponent } from './disconnect-dialog-box/disconnect-dialog-box.component';
import { FacebookAdLeadsService } from './facebook-ad-leads.service';

@Component({
  selector: 'app-facebook-ad-leads',
  templateUrl: './facebook-ad-leads.component.html',
  styleUrls: ['./facebook-ad-leads.component.scss'],
  providers: [
    {
      provide: 'SAVE_ON_CHANGES',
      useValue: true,
    },
  ],
})
export class FacebookAdLeadsComponent {
  pageID$ = this.facebookAdLeadsService.pageID$;
  connectedPageDisplayName$ = this.facebookAdLeadsService.pageDisplayName$;
  connectedPageURL$ = this.facebookAdLeadsService.pageID$.pipe(map((id) => `https://facebook.com/${id}`));
  tokenIsInvalid$ = this.facebookAdLeadsService.tokenIsInvalid$;

  constructor(
    readonly translate: TranslateService,
    private readonly facebookAdLeadsService: FacebookAdLeadsService,
    private dialog: MatDialog,
  ) {}

  showConfirmDisconnectDialogBox(): void {
    this.facebookAdLeadsService.partnerIDAndPageID$.pipe(take(1)).subscribe(() => {
      this.dialog.open(DisconnectDialogBoxComponent, {
        autoFocus: true,
        width: '33%',
      });
    });
  }

  sendUserToFacebookToConnect(): void {
    this.facebookAdLeadsService
      .urlToSendUserToFacebookToConnect()
      .pipe(take(1))
      .subscribe((url) => (window.location.href = url));
  }
}
